var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button is-dark is-outlined is-small",attrs:{"title":"Edit scene details"},on:{"click":function($event){return _vm.editScene(_vm.item)}}},[_c('b-icon',{attrs:{"pack":"mdi","icon":"lead-pencil","size":"is-small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }